export const VIEW_QUICK_FILTERS_SETTINGS_EXPERIENCE_NAME = 'viewQuickFiltersSettings';
export const ADD_QUICK_FILTER_ACTION_SUBJECT = 'addQuickFilter';
export const UPDATE_QUICK_FILTER_ACTION_SUBJECT = 'updateQuickFilter';
export const DELETE_QUICK_FILTER_ACTION_SUBJECT = 'deleteQuickFilter';
export const RANK_QUICK_FILTER_ACTION_SUBJECT = 'rankQuickFilter';
